import { Attr, Model } from '@aclass/core/decorators/orm.decorator';
import { Model as Entity } from 'redux-orm';

export interface IExceptionRangeData {

    readonly id: number;

    readonly dayStart: string;

    readonly dayEnd: string;
}

@Model({
    name: 'ExceptionRange'
})
export class ExceptionRange extends Entity<IExceptionRangeData> {

    @Attr() readonly id: number | null;

    @Attr() readonly dayStart: string | null;

    @Attr() readonly dayEnd: string | null;
}
